module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageNotFound":"Pagina non trovata"}}')
  delete Component.options._Ctor
}
